$(document).on('click','.projects-tab-title-button',function(){
    $(document).find('.projects-tab-title').removeClass('active');
    $(this).parent().addClass('active');
    var selfType = $(this).data('type');
    if(selfType == 'all-projects'){
      $(document).find('.projects-tab-project').show();
    }else{
      $(document).find('.projects-tab-project').hide();
      $(document).find('.projects-tab-projects [data-type="'+selfType+'"]').show();  
    }
  
});
// $(document).ready(function(){
//   Fancybox.bind('[data-fancybox="gallery"]', {
//     Carousel: {
//     infinite: false,
//   },
//   Slideshow: {
//     playOnStart: true,
//     timeout: 3000,
//   },
//   Toolbar: {
//     display: {
//       left: [],
//       middle: [],
//       right: ["slideshow", "close"],
//     },
//   },
//   Images: {
//     zoom: false,
//   },
//   });
// })
// $("a.grouped_elements").fancybox();


$(document).ready(function(){
  if(window.location.href.indexOf('projects') > -1){
    var locationSplit = window.location.href.split('?');
    $(document).find('[data-type="'+locationSplit[1]+'"].projects-tab-title-button').trigger('click');
  }
})